import PropTypes from "prop-types";
export const featureReelSlidesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    sys: PropTypes.shape({
      contentType: PropTypes.shape({
        sys: PropTypes.shape({
          id: PropTypes.string,
        }),
      }),
    }),
    fields: PropTypes.shape({
      name: PropTypes.string,
      cta: PropTypes.shape({
        fields: PropTypes.shape({
          name: PropTypes.string,
          webRoute: PropTypes.string,
          callToAction: PropTypes.string,
        }),
      }),
      media: PropTypes.shape({
        sys: PropTypes.shape({
          contentType: PropTypes.shape({
            sys: PropTypes.shape({
              id: PropTypes.string,
            }),
          }),
        }),
        fields: PropTypes.shape({
          name: PropTypes.string,
          title: PropTypes.string,
          videoUrl: PropTypes.string,
          videoPreviewImageUrl: PropTypes.string,
        }),
      }),
    }),
  })
).isRequired;
export const entryPointVideoPropType = PropTypes.shape({
  sys: PropTypes.shape({
    contentType: PropTypes.shape({
      sys: PropTypes.shape({
        id: PropTypes.string,
      }),
    }),
  }),
  fields: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string,
    videoUrl: PropTypes.string,
    videoPreviewImageUrl: PropTypes.string,
  }),
});
